  document.addEventListener("DOMContentLoaded", (event) => {

    const urlParams = new URLSearchParams(window.location.search);
    const endport = window.customMapEndPort || urlParams.get('endport');
    const startport = window.customMapStartPort || urlParams.get('startport');

    const endPortElement = document.getElementById('endPort');
    const startPortElement = document.getElementById('startPort');
    
    // Show loading overlay
    const loadingOverlayEnd = document.getElementById('endPortLoadingOverlay');
    const loadingOverlayStart = document.getElementById('startPortLoadingOverlay');

    if (loadingOverlayEnd) {
      loadingOverlayEnd.style.display = 'flex';
      console.log("END PORT: Loading overlay displayed");
    }
        
    if (loadingOverlayStart) {
      loadingOverlayStart.style.display = 'flex';
    }


    let ports = [];
    
    // Fallback data in case the API fails - using different ports than the start port
    const fallbackPortsEnd = [
      { name: "Rome", country: "Italy", display_name: "Rome - Italy" },
      { name: "New York", country: "USA", display_name: "New York - USA" },
      { name: "Athens", country: "Greece", display_name: "Athens - Greece" },
      { name: "Copenhagen", country: "Denmark", display_name: "Copenhagen - Denmark" },
      { name: "Tokyo", country: "Japan", display_name: "Tokyo - Japan" },
      { name: "Vancouver", country: "Canada", display_name: "Vancouver - Canada" },
      { name: "Dubai", country: "UAE", display_name: "Dubai - UAE" },
      { name: "Shanghai", country: "China", display_name: "Shanghai - China" },
      { name: "San Juan", country: "Puerto Rico", display_name: "San Juan - Puerto Rico" },
      { name: "Reykjavik", country: "Iceland", display_name: "Reykjavik - Iceland" },
      { name: "Sydney", country: "Australia", display_name: "Sydney - Australia" },
      { name: "Auckland", country: "New Zealand", display_name: "Auckland - New Zealand" },
      { name: "Rio de Janeiro", country: "Brazil", display_name: "Rio de Janeiro - Brazil" },
      { name: "Mumbai", country: "India", display_name: "Mumbai - India" },
      { name: "Oslo", country: "Norway", display_name: "Oslo - Norway" }
    ];

    const fallbackPortsStart = [
      { name: "Barcelona", country: "Spain", display_name: "Barcelona - Spain" },
      { name: "Miami", country: "USA", display_name: "Miami - USA" },
      { name: "Venice", country: "Italy", display_name: "Venice - Italy" },
      { name: "Southampton", country: "UK", display_name: "Southampton - UK" },
      { name: "Sydney", country: "Australia", display_name: "Sydney - Australia" },
      { name: "Singapore", country: "Singapore", display_name: "Singapore - Singapore" },
      { name: "Honolulu", country: "USA", display_name: "Honolulu - USA" },
      { name: "Cape Town", country: "South Africa", display_name: "Cape Town - South Africa" },
      { name: "Amsterdam", country: "Netherlands", display_name: "Amsterdam - Netherlands" },
      { name: "Lisbon", country: "Portugal", display_name: "Lisbon - Portugal" },
      { name: "Seattle", country: "USA", display_name: "Seattle - USA" },
      { name: "Hong Kong", country: "China", display_name: "Hong Kong - China" },
      { name: "Buenos Aires", country: "Argentina", display_name: "Buenos Aires - Argentina" },
      { name: "Stockholm", country: "Sweden", display_name: "Stockholm - Sweden" },
      { name: "Ft. Lauderdale", country: "USA", display_name: "Ft. Lauderdale - USA" }
    ];
    
    function fetchPorts() {
      if (!window.CruiseDataUtils) {
          useFallbackPorts(endPortElement, fallbackPortsEnd, '#endPort', 'end-');
          useFallbackPorts(startPortElement, fallbackPortsStart, '#startPort' , '');
        return;
      }
      
      // Use the shared fetch function
      CruiseDataUtils.fetchPorts()
        .then(portsData => {
          console.log(`START PORT and END PORT: Received ${portsData.length} ports from shared function`);
          ports = portsData;
          hideLoadingSpinner();
          initializeSelectize(endPortElement, portsData, '#endPort', 'end-');
          initializeSelectize(startPortElement, portsData, '#startPort' , '');
        })
        .catch(error => {
          console.error("START PORT and END PORT: Error using shared ports function:", error);
          useFallbackPorts(endPortElement, fallbackPortsEnd, '#endPort', 'end-') ;
          useFallbackPorts(startPortElement, fallbackPortsStart, '#startPort' , '');
        });
    }
    
    function useFallbackPorts(portElement, fallbackPorts, portID, slug) {
      hideLoadingSpinner();
      setTimeout(() => {
        initializeSelectize(portElement,fallbackPorts, portID, slug);
      }, 300);
    }
    
    function hideLoadingSpinner() {
      const overlayEnd = document.getElementById('endPortLoadingOverlay');
      const overlayStart = document.getElementById('startPortLoadingOverlay');

      if (overlayEnd) {
        overlayEnd.style.display = 'none';
      }
      if (overlayStart) {
        overlayStart.style.display = 'none';
      }
    }
    
    function initializeSelectize(portElement, portsData ,portID, slug) {
      console.log(`START PORT and END PORT: Initializing selectize with ${portsData.length} ports`);
      
      // Only initialize if jQuery and Selectize are available
      if (typeof $ === 'undefined') {
        console.error("START PORT and END PORT: jQuery is not available");
        return;
      }
      
      if (typeof $.fn.selectize === 'undefined') {
        console.error("START PORT and END PORT: Selectize is not available");
        return;
      }
      
      try {
        // Ensure the element exists
        
        if (!portElement) {
          console.error("START PORT and END PORT: Element not found in DOM");
          return;
        }
        
        
        // Check if selectize has already been initialized
        if (portElement.selectize) {
          portElement.selectize.destroy();
        }
        
        const select = $(portID).selectize({
          valueField: 'display_name',
          labelField: 'name',
          searchField: ['name', 'country', 'display_name'],
          placeholder: 'Type to search for a port...',
          openOnFocus: true,
          maxItems: 1,
          preload: true,
          maxOptions: 10000,
          
          // Group by country
          optgroupField: 'country',
          optgroupLabelField: 'country',
          optgroupValueField: 'country',
          
          render: {
            option: function(item, escape) {
              return `
                <div class="${slug}port-option">
                  <div class="${slug}port-display">
                    <span class="${slug}port-name">${escape(item.name)}</span>
                    <span class="${slug}separator"> - </span>
                    <span class="${slug}port-country">${escape(item.country)}</span>
                  </div>
                </div>`;
            },
            item: function(item, escape) {
              // Display port name and country with the same styling
              return `<div class="selected-item">${escape(item.name)} - ${escape(item.country)}</div>`;
            },
            optgroup_header: function(data, escape) {
              return `<div class="cruise-line-header">${escape(data.country)}</div>`;
            }
          },
          
          onType: function(str) {
            const selectize = this;
          
            // Always open the dropdown when typing
            if (str.length >= 1) {
              selectize.open();
              
              // If we're not seeing expected results, log what we have
              const options = Object.values(selectize.options);
              console.log(`${portID}: Search for '${str}' - Total options: ${options.length}`);
              
              // Log a sample of matching options
              const matchingSample = options.filter(
                option => option.name.toLowerCase().includes(str.toLowerCase())
              ).slice(0, 5);
              
              if (matchingSample.length > 0) {
                console.log(`${portID}: First few matching options for '${str}':`, matchingSample);
              } else {
                console.log(`${portID}: No matches found for '${str}'`);
              }
            }
          },
          
          onDropdownOpen: function() {
            console.log(`${portID}: Dropdown opened, options count:`, Object.keys(this.options).length);
            
            // Direct DOM manipulation to fix divider issues
            setTimeout(() => {
              try {
                // Remove all dividers and borders from options
                document.querySelectorAll('.selectize-dropdown-content .option').forEach(option => {
                  option.style.borderBottom = 'none';
                  option.style.borderTop = 'none';
                  option.style.margin = '0';
                  
                  // Add custom divider at the bottom of each option if not already added
                  if (!option.classList.contains('divider-added')) {
                    const divider = document.createElement('div');
                    divider.className = 'custom-port-divider';
                    divider.style.height = '1px';
                    divider.style.backgroundColor = '#eee';
                    divider.style.margin = '0';
                    divider.style.padding = '0';
                    option.appendChild(divider);
                    option.classList.add('divider-added');
                  }
                });
                
                // Remove dividers from the last port in each group
                document.querySelectorAll('.selectize-dropdown-content .optgroup').forEach(group => {
                  const options = group.querySelectorAll('.option');
                  if (options.length > 0) {
                    const lastOption = options[options.length - 1];
                    const divider = lastOption.querySelector('.custom-port-divider');
                    if (divider) {
                      divider.style.display = 'none';
                    }
                  }
                });
              } catch (e) {
                console.error(`${portID}: Error fixing dividers:`, e);
              }
            }, 10);
          },
          
          onFocus: function() {
            this.open();
          }
        });

        const selectize = select[0].selectize;
        
        // Store selectize instance on element for future reference
        portElement.selectize = selectize;
        
        // Clear any existing options
        selectize.clear();
        selectize.clearOptions();
        
        console.log(`${portID}: Adding port data to dropdown`);
        
        // First, gather all countries and sort them alphabetically
        let countriesList = [];
        portsData.forEach(port => {
          if (port.name && port.country && !countriesList.includes(port.country)) {
            countriesList.push(port.country);
          }
        });
        
        // Sort countries alphabetically
        countriesList.sort((a, b) => a.localeCompare(b));
        console.log(`${portID}: Sorted countries alphabetically:`, countriesList);
        
        // Add optgroups first in alphabetical order
        countriesList.forEach(country => {
          selectize.addOptionGroup(country, {
            country: country
          });
        });
        
        // Group ports by country
        const portsByCountry = {};
        countriesList.forEach(country => {
          portsByCountry[country] = [];
        });
        
        // Populate groups
        portsData.forEach(port => {
          if (!port.name || !port.country) return;
          
          const country = port.country || 'Other';
          if (!portsByCountry[country]) {
            portsByCountry[country] = [];
          }
          portsByCountry[country].push(port);
        });
        
        // Sort ports alphabetically within each country
        Object.keys(portsByCountry).forEach(country => {
          portsByCountry[country].sort((a, b) => a.name.localeCompare(b.name));
        });
        
        // Now prepare batches of ports for processing
        let flattenedPorts = [];
        countriesList.forEach(country => {
          if (portsByCountry[country]) {
            flattenedPorts = flattenedPorts.concat(portsByCountry[country]);
          }
        });
        
        // Add options in batches to prevent UI freezing
        const batchSize = 200;
        let currentBatch = 0;
        
        function addBatch() {
          const start = currentBatch * batchSize;
          const end = Math.min(start + batchSize, flattenedPorts.length);
          const batch = flattenedPorts.slice(start, end);
          
          console.log(`${portID}: Processing batch ${currentBatch+1} (${start}-${end}), total ports: ${flattenedPorts.length}`);
          
          // Process this batch
          batch.forEach(port => {
            if (!port.name || !port.country) return;
            
            // Add port option with formatted display name
            const display_name = port.display_name || `${port.name}${port.country ? ` - ${port.country}` : ''}`;
            
            selectize.addOption({
              name: port.name,
              country: port.country || '',
              display_name: display_name
            });
          });
          
          currentBatch++;
          
          // If there are more ports to add, schedule next batch
          if (end < flattenedPorts.length) {
            setTimeout(addBatch, 5);
          } else {
            console.log(`${portID}: All port data added to dropdown`);
            console.log(`${portID}: Options count:`, Object.keys(selectize.options).length);
            console.log(`${portID}: First few options:`, Object.keys(selectize.options).slice(0, 3).map(key => selectize.options[key]));
            
            // Force dropdown refresh
            selectize.refreshOptions(false);
            
            // Set value from URL parameter if available
            if (endport && portID === '#endPort') {
              console.log("END PORT: Setting value from URL parameter:", endport);
              const selectedPort = portsData.find(port => 
                (port.display_name && port.display_name.toLowerCase() === endport.toLowerCase()) ||
                (port.name && port.name.toLowerCase() === endport.toLowerCase())
              );
              
              if (selectedPort) {
                const display_name = selectedPort.display_name || 
                  `${selectedPort.name}${selectedPort.country ? ` - ${selectedPort.country}` : ''}`;
                selectize.setValue(display_name);
              }
            }

            if (startport && portID === '#startPort') {
              console.log("START PORT: Setting value from URL parameter:", startport);
              const selectedPort = portsData.find(port => 
                (port.display_name && port.display_name.toLowerCase() === startport.toLowerCase()) ||
                (port.name && port.name.toLowerCase() === startport.toLowerCase())
              );
              
              if (selectedPort) {
                const display_name = selectedPort.display_name || 
                  `${selectedPort.name}${selectedPort.country ? ` - ${selectedPort.country}` : ''}`;
                selectize.setValue(display_name);
              }
            }
            
          }
        }
        
        // Start adding options
        addBatch();
        
      } catch (error) {
        console.error(`${portID}: Error in initializeSelectize:`, error);
      }
    }
    
    // Add click event listener to initialize on demand if needed
    document.getElementById('endPort').addEventListener('click', function() {
      console.log("END PORT: Element clicked");
      if (this.selectize) {
        console.log("END PORT: Element has selectize instance, opening dropdown");
        this.selectize.open();
      } else if (ports.length > 0) {
        console.log("END PORT: Reinitializing selectize on click");
        initializeSelectize(ports);
      } else if (fallbackPortsEnd) {
        console.log("END PORT: Using fallback data on click");
        initializeSelectize(fallbackPortsEnd);
      }
    });

    fetchPorts();
  });